import { useParams } from 'react-router-dom';

export const useAgencyId = () => {
  const { agency_id = '' } = useParams<{ agency_id: string }>();
  return { agency_id };
};
